import styled from 'styled-components';

import { ModalHeading } from 'components/modal';

import { ModalContent } from '../styled';

export const Container = styled(ModalContent)`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const StyledModalHeader = styled(ModalHeading)`
  margin: 0 auto 1rem;
  font-size: 2rem;
  line-height: 2rem;
  height: 2.5rem;
`;

export const LoadingText = styled.p`
  text-align: center;
  font-size: 0.9375rem;
  line-height: 1.33;
  font-family: ${Styles.fontFamily.body};
  padding: 0.4375rem 2.5rem;
`;

export const LoadingGraphic = styled.img`
  height: 13.75rem;
  margin: 1.875rem;
  justify-self: center;
  ${Styles.desktop`
    margin: 3.125rem;
  `};
`;

export const GraphicTextWrapper = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
`;
